import { HERO_IMG } from "./data";

export default function CoverPage() {
  return (
    <section className="page cover" data-testid="page-cover">
      <div className="cover-hero">
        <img src={HERO_IMG} alt="Solar rooftop installation" />
      </div>
      <div className="cover-overlay" />
      <div className="cover-grid" />
      <div className="cover-content">
        <div className="cover-top">
          <div className="cover-logo">
            <div className="sun" />
            <div className="wordmark">
              <span className="name">INPACE POWER</span>
              <span className="tag">Solar Energy · Bangalore</span>
            </div>
          </div>
          <div className="cover-year">
            <strong>Edition</strong>
            MMXXVI · Vol. I
          </div>
        </div>

        <div className="cover-title-block">
          <div className="eyebrow" style={{ marginBottom: 22 }}>The Company Brochure</div>
          <h1 className="cover-title">
            Powered by<br /> <em>Our People.</em><br />Fuelled by<br /><em>The Sun.</em>
          </h1>
          <div className="cover-title-rule" />
          <p className="cover-sub">
            A passionate in-house team of certified engineers and technicians delivering end-to-end solar rooftop solutions across Karnataka.
          </p>

          <div className="cover-meta">
            <div className="cover-meta-col">
              <div className="label">Headquarters</div>
              <div className="value">Bangalore, India</div>
            </div>
            <div className="cover-meta-col">
              <div className="label">Experience</div>
              <div className="value">3+ Years · 240+ Installs</div>
            </div>
            <div className="cover-meta-col">
              <div className="label">Director</div>
              <div className="value">Santhosha Kumar R</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
